import axios from "axios";

import toast from "react-hot-toast";

import { ENDPOINT } from "../../constant/environment";
import { toastMessage } from "../../utils/ToastProvider";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { Messages } from "../../constant/messages/toastMessages";
import { isValidJWT } from "../../utils/authentication/isValidJWT";

export async function modifyItineraryAPI(
  accessJWT: string,
  isMobile: boolean,
  userId: string,
  userInput: string,
  messages: any,
  currentItineray: any,
  signal?: AbortSignal,
  appConfig?: any
) {
  const URL = `${ENDPOINT}/app/v1/itineraries/modifySearch`;
  let config = getHeaderConfig(signal, accessJWT);
  let body = {
    userId,
    userInput,
    messages,
    currentItineray,
  };
  if (!accessJWT || !isValidJWT(accessJWT)) return null;
  try {
    const response = await axios.post(URL, encryptData(body), config);
    const decryptedData = decryptData(response?.data);
    consoleLog(["MODIFY ITINERARY RESPONSE", JSON.parse(decryptedData)]);
    return decryptedData ? JSON.parse(decryptedData) : null;
  } catch (error: any) {
    if (error?.code !== "ERR_CANCELED" && isMobile) toast.dismiss();
    toastMessage.error(Messages["api.break.down"].messageTitle, Messages["api.break.down"].message);
    consoleLog(["MODIFY ITINERARY ERROR", error]);
    return null;
  }
}
